// extracted by mini-css-extract-plugin
module.exports = {"appsDownloadButtons":"FooterApps_appsDownloadButtons__RjRev"};